export default __webpack_public_path__ + "ace4749ff92dc53fa4dc008f06a964a9.svg";